






























































































































import {Component, Emit, Mixins, Watch, Prop} from "vue-property-decorator";
import {mapGetters, mapState} from "vuex";
import {formatDate} from "@/lib/date";
import {prepareMoney} from "@/assets/scripts/utils";
import {DocumentsByContract} from "@/models/contract";
import XDataTable from "../hoc/Table.vue";
import XDropdownWithDatePicker from "../hoc/DropdownWithDatePicker.vue";
import XDropdownWithRadioButtons from "../hoc/DropdownWithRadioButtons.vue";
import ActionDropdown from "../ActionDropdown.vue";
import XButton from "../SimpleButton.vue";
import {DocumentsAsReqBody} from "@/models/app-api";
import AppApiMixin from "@/components/mixins/AppApi.vue";

@Component({
  components: {
    XDataTable,
    XDropdownWithDatePicker,
    XDropdownWithRadioButtons,
    ActionDropdown,
    XButton,
  },
  computed: {
    ...mapState({ appEnviroment: "appEnviroment" }),
    ...mapGetters({
      contractId: "contract/id",
    }),
  },
  filters: {
    formatDate(value: string): string {
      return formatDate(value, "full");
    },
    prepareMoney,
  },
})
class DocumentTable extends Mixins(AppApiMixin) {
  [x: string]: any;

  headers = [
    { text: "Документ", value: "type", width: "30%" },
    { text: "Аналитика", value: "analytics", width: "12.5%" },
    { text: "Тема", value: "theme", width: "5%" },
    {
      text: "Сумма с НДС",
      value: "sumWithTax",
      width: "15%",
      align: "end",
    },
    {
      text: "Сумма без НДС",
      value: "sumWithoutTax",
      width: "15%",
      align: "end",
    },
    {
      text: "К оплате",
      value: "sumToPaid",
      width: "15%",
      align: "end",
    },
  ];

  docKeys = [
    ["тип", "номер", "дата"],
    "аналитика",
    "тема",
    "суммасндс",
    "суммабезндс",
    "остаток",
  ];

  humanDocTypeByValue = {
    СФ: "Реализация",
    ПЛАТ: "Входящий платеж",
    ПКО: "Приходный ордер",
  };

  selectedAll = false;
  selectedRows: boolean[] = [];

  // Свойства, использующиеся в элементах шапки таблицы
  // (прим: расположены по порядку элементов).
  dates: string[] = [];

  docsProps: DocumentsAsReqBody = {
    contractId: -1,
    type: 0,
    noPayment: 0,
    from: "",
    to: "",
  };
  documentList: DocumentsByContract[] = [];

  /**
   * Вычисляемое свойство, значением которого является объект. Ключами такого
   * объекта являются значения свойств value объекта headers, а значениями - строки,
   * использующиеся в качестве css-классов td-элементов таблицы, что позволяет
   * определять стили для отдельного столбца. Например, для ячейки, расположенной
   * в столбце с заголовком "к оплате", будет создана следующая строка:
   * "data-table__td data-table__td_header_sum-to-paid" (см. vue-dev-tools).
   */
  public get tdClassesByHeaders() {
    const headerValues = this.headers.map(({ value }) => value);
    const tdClasses: { [headerValue: string]: string } = {};

    return headerValues.reduce((acc, headerValue) => {
      const headerId = headerValue.replace("document", "");
      let counter = 0;

      const headerIdKebabCase = headerId.replace(/[A-Z]/g, (match) => {
        const result = match.toLowerCase();
        return counter++ ? `-${result}` : result;
      });

      return {
        ...acc,
        [headerValue]: `data-table__td data-table__td_header_${headerIdKebabCase}`,
      };
    }, tdClasses);
  }

  public get runUpdate(): string {
    const { dates } = this;

    return [
      dates.join(" - "),
      0,
      0,
    ].join(" | ");
  }

  public get docsLength(): number {
    return this.documentList.length;
  }

  public get runSelect(): string {
    return this.selectedRows.join(" ");
  }

  public get totalSelectedRows(): number {
    let selectedRows = this.selectedRows.filter((state) => state).length;
    this.selectedRowsSum;
    return selectedRows;
  }

  // работа с общей суммой по документам
  amount: number = 0;
  @Watch("amount")
  public setAmountChanged() {
    this.emitAmountEvt();
  }
  @Emit()
  private emitAmountEvt() {
    this.$emit(
      "update:amount",
      this.amount
    );
  }
  // работа со списком документов
  docs: any[] = [];
  @Watch("docs")
  public setDocsChanged() {
    this.emitDocsEvt();
  }
  @Emit()
  private emitDocsEvt() {
    this.$emit(
      "update:docs",
      this.docs
    );
  }

  public get selectedRowsSum(): number {
    const { documentList, selectedRows } = this;
    this.amount = documentList.reduce(
      (acc, document, i) => (selectedRows[i] ? acc + document["остаток"] : acc),
      0
    );
    this.docs = documentList.filter((document, i) => (selectedRows[i])).map((item) => {
      return {
        'Счет': item['документ'],
        'Сумма': item['остаток'],
      }
    });
    return this.amount;
  }

  @Emit()
  public emitUpdateEvt() {
    const [from, to] = this.dates;
    this.docsProps = { ...this.docsProps, ...{ contractId: this.contractId, from, to } };
  }

  public get preparedDocuments() {
    return this.documentList.map((document) => {
      return this.docKeys.map((keyByTd) => {
        return Array.isArray(keyByTd)
          ? keyByTd.map((key) => document[key])
          : document[keyByTd];
      });
    });
  }

  @Watch("docsProps")
  public docsPropsChanged() {
    this.getDocumentsByContract(
      this.docsProps,
      (documentList: DocumentsByContract[]) => {
        this.documentList = documentList.filter(item => item['остаток'] > 0);
      }
    );
  }
  /**
   * Использовать значение вычисляемого свойства runUpdate в качестве сигнала
   * для запуска события "update:docsProps". Такой vue-трюк позволяет одновременно
   * контролировать значения нескольких свойств состояния.
   */
  @Watch("runUpdate")
  public runUpdateChanged() {
    this.emitUpdateEvt();
  }

  @Watch("docsLength")
  public docsLengthChanged() {
    this.selectedRows = Array(this.docsLength).fill(false);
  }

  @Watch("runSelect")
  public runSelectChanged() {
    this.selectedAll = !this.selectedRows.some((isSelected) => !isSelected);
  }
}

export default DocumentTable;
